<ngx-slick-carousel class="cust-about-us" #slickModal="slick-carousel" [config]="slideConfig" (init)="slickInit()"
  (breakpoint)="breakpoint()" (afterChange)="afterChange()" (beforeChange)="beforeChange()">
  <div ngxSlickItem  *ngFor="let slide of slides" class="slide p-3">
    <div class="container">
      <div class="row justify-content-center align-items-center">
        <div class="col-md-4 text-center" >
          <img [src]="slide.img" alt="Random first slide" width="55%" height="auto" class="img-fluid mx-auto d-block">
          <p class="text-center mt-10 mb-0" [innerHTML]="slide.name"></p>
          <p class="text-center" [innerHTML]="slide.des"></p>
        </div>
        <div class="col-md-8  p-4 text-center box-shadow-only">
          <p class="text-center para-class" [innerHTML]="slide.message"></p>
        </div>
      </div>
    </div>
  </div>
</ngx-slick-carousel>